/**
* @Description: card
* @author XuZiYu
* @date 2021-07-17 15:26
*/
<template>
  <div class="wrapper">
    <ctl-header :title="'理论保障卡'" :onBack="goBack"></ctl-header>

    <div class="card-item">
      <div class="card-item-name">科一保障卡</div>

      <template v-if="Number(info.ensureActiveFlag1) === 0">
        <img class="tag" src="@/assets/vip/icon_wjh.png" alt="">
        <div class="card-item-rule" v-if="info.ensureSettingDetailDTO">
          <div class="left">{{
            `激活方式：${info.ensureSettingDetailDTO.daysOne}天内模拟考试` +
            `${info.ensureSettingDetailDTO.seriesFlagOne ? '连续': ''}` +
            `${info.ensureSettingDetailDTO.timesOne}次≥` +
            `${info.ensureSettingDetailDTO.scoreOne}`}}
          </div>
          <div class="right"><b class="b">{{info.qualifiedTime1}}</b>/{{info.ensureSettingDetailDTO.timesOne}}</div>
        </div>
        <div class="btn-active"
             v-if="info.ensureSettingDetailDTO && (Number(info.qualifiedTime1) === Number(info.ensureSettingDetailDTO.timesOne))"
             @click="onActive(1)"><span class="center">立即激活</span>
        </div>
        <div class="btn-go-exam" v-else @click="goExam(1)"><span class="center">去模拟考试</span></div>
      </template>

      <template v-if="Number(info.ensureActiveFlag1) === 1">
        <img class="tag" src="@/assets/vip/icon_yjh.png" alt="">
        <div class="time">生效日期：{{info.validTime1}}</div>
        <div class="btn-go-list" @click="onList(1,info.compensateId1)"><span class="center">补偿记录</span>
          <div class="badge" v-if="info.compensate1">{{info.compensate1}}</div>
        </div>
        <div class="btn-go-apply" @click="onApply(1,info.ensureActiveFlag1,info.compensateId1)"><span class="center">申请补偿</span></div>
      </template>

      <template v-if="Number(info.ensureActiveFlag1) === 2">
        <img class="tag" src="@/assets/vip/icon_ysy.png" alt="">
        <div class="time">生效日期：{{info.validTime1}}</div>
        <div class="btn-go-list" @click="onList(1,info.compensateId1)"><span class="center">补偿记录</span>
          <div class="badge" v-if="info.compensate1">{{info.compensate1}}</div>
        </div>
        <div class="btn-go-apply" @click="onApply(1,info.ensureActiveFlag1,info.compensateId1)"><span class="center">申请补偿</span></div>
      </template>
    </div>

    <div class="card-item">
      <div class="card-item-name">科四保障卡</div>
      <template v-if="Number(info.ensureActiveFlag4) === 0">
        <img class="tag" src="@/assets/vip/icon_wjh.png" alt="">
        <div class="card-item-rule" v-if="info.ensureSettingDetailDTO">
          <div class="left">{{
            `激活方式：${info.ensureSettingDetailDTO.daysOne}天内模拟考试` +
            `${info.ensureSettingDetailDTO.seriesFlagOne ? '连续': ''}` +
            `${info.ensureSettingDetailDTO.timesFour}次≥` +
            `${info.ensureSettingDetailDTO.scoreFour}`}}
          </div>
          <div class="right"><b class="b">{{info.qualifiedTime4}}</b>/{{info.ensureSettingDetailDTO.timesFour}}</div>
        </div>
        <div class="btn-active"
             v-if="info.ensureSettingDetailDTO && (Number(info.qualifiedTime4) === Number(info.ensureSettingDetailDTO.timesFour))"
             @click="onActive(4)"><span class="center">立即激活</span>
        </div>
        <div class="btn-go-exam" v-else @click="goExam(4)"><span class="center">去模拟考试</span></div>
      </template>

      <template v-if="Number(info.ensureActiveFlag4) === 1">
        <img class="tag" src="@/assets/vip/icon_yjh.png" alt="">
        <div class="time">生效日期：{{info.validTime4}}</div>
        <div class="btn-go-list" @click="onList(4,info.compensateId4)"><span class="center">补偿记录</span>
          <div class="badge" v-if="info.compensate4">{{info.compensate4}}</div>
        </div>
        <div class="btn-go-apply" @click="onApply(4,info.ensureActiveFlag4,info.compensateId4)"><span class="center">申请补偿</span></div>
      </template>

      <template v-if="Number(info.ensureActiveFlag4) === 2">
        <img class="tag" src="@/assets/vip/icon_ysy.png" alt="">
        <div class="time">生效日期：{{info.validTime4}}</div>
        <div class="btn-go-list" @click="onList(4,info.compensateId4)"><span class="center">补偿记录</span>
          <div class="badge" v-if="info.compensate4">{{info.compensate4}}</div>
        </div>
        <div class="btn-go-apply" @click="onApply(4,info.ensureActiveFlag4,info.compensateId4)"><span class="center">申请补偿</span></div>
      </template>
    </div>

    <div class="rule">补偿说明：
      • 100元理论保障卡包含科目一50元和科目四50元（各补偿一次）；
      • 补偿条件：成绩分数需在补偿范围之内（分数在60-89分之间），保障卡必须在真实考试前一天完成激活，否则不予补偿；
      • 审核时间：补偿申请提交后5-7个工作日内完成审核，打款将会发放至填写的账户信息，请确保账户为本人所有；
      • 如有疑问，可联系斑斑客服400-6039603
    </div>

    <ctl-dialog :value="dialogValue"></ctl-dialog>
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
    name: 'card',
    components: {
        [Toast.name]: Toast
    },
    data () {
        return {
            // 激活参数
            vipUserId: '',
            // 理论保障卡信息
            info: {},
            // 弹窗参数
            dialogValue: {
                visible: false
            }
        }
    },
    methods: {
        // 返回
        goBack () {
            this.$router.back()
        },
        // 进入理论保障卡
        initEnsureCard () {
            this.$api.initEnsureCard({ vipUserId: this.vipUserId }).then(res => {
                if (res.status) {
                    this.info = res.result
                } else {
                    this.dialogValue = {
                        visible: true,
                        content: res.message,
                        rightBtnName: '确定',
                        rightBtnMethod: () => {
                            this.dialogValue.visible = false
                            this.goBack()
                        }
                    }
                }
            })
        },
        // 跳转模拟考试
        goExam (v) {
            this.$jsBridge.callBackHandler('pushEaxmPage', { subject: v })
        },
        // 激活保障卡
        onActive (v) {
            this.$api.activeEnsureCard({ vipUserId: this.vipUserId, subject: v }).then(res => {
                if (res.status && res.code === '200') {
                    Toast.success('激活成功')
                    this.initEnsureCard()
                }

                if (res.code === '902') {
                    this.dialogValue = {
                        visible: true,
                        content: '为确保您的保障权益，请先完善个人信息',
                        leftBtnName: '暂不',
                        rightBtnName: '去完善',
                        leftBtnMethod: () => {
                            this.dialogValue.visible = false
                        },
                        rightBtnMethod: () => {
                            this.$router.push({
                                name: 'ensurePerfectInfo',
                                query: { vipUserId: this.info.vipUserId }
                            })
                        }
                    }
                }
            })
        },

        // 点击申请补偿
        onApply (v, status, compensateId) {
            // 判断状态是否已经使用过
            if (Number(status) === 2) {
                this.dialogValue = {
                    visible: true,
                    content: '保障卡已使用，无法再次申请补偿！',
                    rightBtnName: '我知道了',
                    rightBtnMethod: () => {
                        this.dialogValue.visible = false
                    }
                }
                return
            }
            this.$api.initCompensate({ vipUserId: this.vipUserId, subject: v }).then(res => {
                if (res.code === '901') {
                    this.dialogValue = {
                        visible: true,
                        content: '您有一条未完成的申请记录，无法提出新的补充申请！',
                        rightBtnName: '我知道了',
                        rightBtnMethod: () => {
                            this.dialogValue.visible = false
                        }
                    }
                    return
                }
                this.$router.push({
                    name: 'ensureApply',
                    query: { vipUserId: this.vipUserId, subject: v, compensateId: compensateId }
                })
            })
        },
        // 点击补偿记录
        onList (v, compensateId) {
            this.$router.push({
                name: 'ensureList',
                query: { vipUserId: this.vipUserId, subject: v, compensateId: compensateId }
            })
        }
    },
    created () {
        this.vipUserId = this.$route.query.vipUserId

        // 暴露页面刷新方法
        window.ensureCardCallBack = this.initEnsureCard

        this.initEnsureCard()
    }
}
</script>

<style scoped lang="scss">

  .wrapper {
    overflow: hidden;
    width: 100%;
    box-sizing: border-box;
    padding: 0 15px;
  }

  .card-item + .card-item {
    margin: 15px 0 0 0;
  }

  .card-item {
    position: relative;
    text-align: center;
    overflow: hidden;
    margin: 20px 0 0 0;
    width: 345px;
    min-height: 150px;

    background: linear-gradient(135deg, #EAD9C1 0%, #E2C59D 100%);
    box-shadow: 0 5px 5px 0 rgba(228, 201, 165, 0.2);
    border-radius: 5px;

    .card-item-name {
      margin: 20px 0 0 15px;

      text-align: left;
      font-size: 24px;
      line-height: 1;
      font-weight: 600;
      color: #926E3D;
    }

    .time {
      line-height: 1;
      text-align: left;
      margin: 10px 0 0 15px;
      font-size: 13px;
      font-weight: 400;
      color: #926E3D;
    }

    .card-item-rule {
      min-height: 13px;
      line-height: 1;
      margin-top: 10px;
      display: flex;
      align-items: center;
      padding: 0 13px 0 15px;

      font-size: 13px;
      font-weight: 400;
      color: #926E3D;

      .left {
        white-space: normal;
        text-align: left;
        flex: 1;
      }

      .b {
        font-weight: normal;
        color: #FF5E03;
      }
    }

    .btn-go-list, .btn-go-apply, .btn-go-exam, .btn-active {
      position: relative;
      margin-top: 30px;
      margin-bottom: 20px;
      display: inline-block;
      width: 100px;
      height: 30px;
      line-height: 1;
      font-size: 15px;
      font-weight: 400;
      color: #926E3D;
      background: #FFFFFF;
      border-radius: 16px;

      .center{
        line-height: 1;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .badge {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 15px;
        height: 15px;
        position: absolute;
        right: 0;
        top: -7.5px;
        border-radius: 50%;
        background-color: #FF5050;
        font-size: 12px;
        font-weight: 400;
        color: #FFFFFF;
      }
    }

    .btn-go-exam{
      width: 115px;
    }

    .btn-active {
      background-color: #FF5E03;
      color: #fff;
    }

    .btn-go-apply {
      margin-left: 20px;
    }

    .tag {
      width: 65px;
      position: absolute;
      right: 0;
      top: 0;
    }

  }

  .rule {
    margin-top: 20px;
    white-space: pre-line;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
  }

</style>
